import { useState, useEffect, useMemo } from 'react';
import { useDataProducts } from './useDataProducts';
import { getItemIdsFromBundles, getLimitedItemIds, isItemIdsInErrorMessage } from '../utils/product-utils';

export const useMultiParentProductsFetch = (bundles) => {
  const [offsetValue, setOffsetValue] = useState(0);
  const [bundleProducts, setBundleProducts] = useState([]);
  const [filteredBundles, setFilteredBundles] = useState(bundles);

  const uniqueItemIds = useMemo(() => getItemIdsFromBundles(bundles), [bundles]);
  const limitedItemIds = getLimitedItemIds(uniqueItemIds, offsetValue);

  const { data: productsData,
    loading: productsLoading, error } = useDataProducts({ itemIds: limitedItemIds, skip: !limitedItemIds?.length });

  useEffect(() => {
    if (!productsLoading && productsData) {
      setBundleProducts((prev) => [...prev, ...productsData.products]);
    }
  }, [productsData, productsLoading]);

  useEffect(() => {
    const bundlesWithoutError = filteredBundles?.filter((bundle) => {
      const itemIdsInBundle = getItemIdsFromBundles([bundle]);
      return !isItemIdsInErrorMessage(itemIdsInBundle, error);
    }) || filteredBundles;
    setFilteredBundles(bundlesWithoutError);
  }, [error]);

  return {
    bundleProducts, offsetValue, setOffsetValue, productsLoading, uniqueItemIds, error, filteredBundles
  };
};